import MedicinesListBlock from './MedicinesListBlock';

export default MedicinesListBlock;
